import rolesApiService from '@/services/api/Roles'

const emptyModel = {
  name: null,
  title: null,
  level: null,
  scope: null,
  abilities: []
}

const emptyFilters = {
  title: null
}

class Role {
  constructor() {
    this.api = rolesApiService
    this.emptyModel = emptyModel
    this.emptyFilters = emptyFilters
  }
}

let role = new Role()

export default role
